import {ChangeEvent, Fragment, ReactElement, ReactNode, useMemo} from 'react';
import classNames from 'classnames';

export enum ProductScoreType {
  rating = 'rating',
  marking = 'marking',
}

interface RadioProductScoreFieldProps {
  name: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  fieldsetClassName?: string;
  checkedValue?: string | number;
  scoreType?: ProductScoreType;
  children?: ReactNode | ReactNode[];
}

export function RadioProductScoreField({
  name,
  onChange,
  checkedValue,
  fieldsetClassName,
  children,
  scoreType = ProductScoreType.marking,
}: RadioProductScoreFieldProps): ReactElement {
  const radioOptions = useMemo(
    () =>
      Object.freeze({
        [ProductScoreType.rating]: [
          {value: 5, label: 'Love'},
          {value: 4, label: 'Great'},
          {value: 3, label: 'Good'},
          {value: 2, label: 'Ok'},
          {value: 1, label: 'Dislike'},
        ],
        [ProductScoreType.marking]: [
          {value: 5, label: '5'},
          {value: 4, label: '4'},
          {value: 3, label: '3'},
          {value: 2, label: '2'},
          {value: 1, label: '1'},
        ],
      })[scoreType],
    [scoreType],
  );

  return (
    <fieldset
      className={classNames('add-rating-radio mt-30', fieldsetClassName, {
        'add-rating-radio-number': scoreType === ProductScoreType.marking,
      })}
    >
      {children}
      {radioOptions.map(({value, label}) => (
        <Fragment key={`${name}-${value}`}>
          <input
            type="radio"
            name={name}
            id={`${name}-${value}`}
            value={value}
            onChange={onChange}
            checked={checkedValue && value === Number(checkedValue)}
          />
          <label htmlFor={`${name}-${value}`}>
            <span>{label}</span>
          </label>
        </Fragment>
      ))}
    </fieldset>
  );
}
